"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileStrategy = void 0;
const detect_browser_1 = require("detect-browser");
const safe_stable_stringify_1 = __importDefault(require("safe-stable-stringify"));
const rfs = __importStar(require("rotating-file-stream"));
const lodash_functions_1 = require("../../util/lodash-functions");
const config_1 = require("../../config");
class FileStrategy {
    get configuration() {
        return config_1.config.get('logs').transports.file;
    }
    constructor() {
        this.applyConfig = this.applyConfig.bind(this);
        config_1.config.on(config_1.config.CONFIG_FILE_UPDATED, this.applyConfig);
        config_1.config.on(config_1.config.CONFIG_SET, this.applyConfig);
    }
    write(methodName, ...args) {
        if (this.writer) {
            const message = this.buildStreamMessage(methodName, args);
            this.writer.write(message);
        }
    }
    initialize() {
        var _a, _b;
        try {
            const isWriteToFile = this.configuration.enabled && ((_a = (0, detect_browser_1.detect)()) === null || _a === void 0 ? void 0 : _a.type) === 'node';
            (_b = this.writer) === null || _b === void 0 ? void 0 : _b.end();
            this.writer = undefined;
            if (isWriteToFile) {
                const { size, maxFiles, interval, maxSize, history } = this.configuration;
                this.writer = rfs.createStream(this.fileNameGenerator.bind(this), {
                    size,
                    maxFiles,
                    interval,
                    maxSize,
                    history: `${history}-${process.pid}.txt`,
                });
            }
            this.prevConfig = (0, lodash_functions_1.cloneDeep)(this.configuration);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('File stream creation error.', error);
        }
    }
    applyConfig() {
        if ((0, lodash_functions_1.isEqual)(this.prevConfig, this.configuration)) {
            return;
        }
        this.initialize();
    }
    buildStreamMessage(methodName, messages) {
        let message = messages.reduce((prev, curr) => {
            let currString = curr;
            if (typeof curr === 'function') {
                currString = '[Function]';
            }
            if (curr instanceof Error) {
                currString = curr.stack;
            }
            if (typeof currString !== 'string') {
                currString = (0, safe_stable_stringify_1.default)(curr);
            }
            return prev + currString + ' ';
        }, '');
        if (methodName.toLowerCase() === 'trace') {
            message = 'Trace: ' + message;
            message += this.getStackTrace();
        }
        message += '\n';
        return message;
    }
    getStackTrace(object = this) {
        Error.captureStackTrace(object);
        return object.stack.replace('Error:', '');
    }
    fileNameGenerator(time, index) {
        const date = typeof time === 'number' ? new Date(time) : time || new Date(Date.now());
        const month = date.getUTCFullYear() + (date.getUTCMonth() + 1 + '').padStart(2, '0');
        const day = (date.getUTCDate() + '').padStart(2, '0');
        const hour = (date.getUTCHours() + '').padStart(2, '0');
        const minute = (date.getUTCMinutes() + '').padStart(2, '0');
        let fileName = `${month}${day}-${hour}${minute}`;
        if (time) {
            fileName += `-${index}`;
        }
        fileName += `-${process.pid}-${this.configuration.name}`;
        return fileName;
    }
}
exports.FileStrategy = FileStrategy;
//# sourceMappingURL=data:application/json;base64,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